import { Icon } from "@/components/common/Icon";
import type { ChatListEntry } from "@/lib/chat";
import { formatRelativeDateTime } from "@/lib/format-datetime";

/** チャット 1 件の行。押すとそのチャットを開く。 */
export function EnvironmentChatRow({
	chat,
	first,
	onSelect,
}: {
	chat: ChatListEntry;
	first: boolean;
	onSelect: () => void;
}) {
	return (
		<button
			type="button"
			data-testid={`environment-chat-row-${chat.id}`}
			style={{
				display: "flex",
				alignItems: "center",
				flexShrink: 0,
				gap: 10,
				padding: "8px 12px",
				background: "transparent",
				border: 0,
				borderTop: first ? 0 : "var(--pane-header-border)",
				fontFamily: "inherit",
				textAlign: "left",
				cursor: "pointer",
			}}
			onMouseEnter={(e) => {
				e.currentTarget.style.background = "var(--overlay-hover)";
			}}
			onMouseLeave={(e) => {
				e.currentTarget.style.background = "transparent";
			}}
			onClick={onSelect}
		>
			<Icon name="chat" size={14} color="var(--fg-2)" />
			<span
				style={{
					flex: 1,
					minWidth: 0,
					fontSize: "var(--text-ui)",
					color: "var(--fg-1)",
					overflow: "hidden",
					textOverflow: "ellipsis",
					whiteSpace: "nowrap",
				}}
			>
				{chat.title?.trim() || "無題のチャット"}
			</span>
			<span
				style={{
					flexShrink: 0,
					fontSize: "var(--text-caption)",
					fontVariantNumeric: "tabular-nums",
					color: "var(--fg-3)",
				}}
			>
				{formatRelativeDateTime(chat.updatedAt)}
			</span>
			<Icon name="chevronR" size={13} color="var(--fg-3)" />
		</button>
	);
}
